import Swiper from 'swiper';
import {isMatchMedia} from '%helpers%/utils';
import {getBreakpoints} from '%widgets%/widget-slider';

export const initiateSliderCarousel = widget => {
  const swiperEl = widget.querySelector('.swiper');

  if (!swiperEl) return;

  const isLargeScreen = () => isMatchMedia('lg');

  const id = widget.id;

  const swiperNextButtons = widget.querySelectorAll('.swiper-btn-next');
  const swiperPrevButtons = widget.querySelectorAll('.swiper-btn-prev');
  const swiperScrollbar = widget.querySelector('.swiper-scrollbar');
  const dropdownWrapper = widget.closest('.dropdown');

  let swiper;
  const countSlides = widget.querySelectorAll('.swiper-slide').length;
  const {swiperLoop, swiperSimulateTouch = true, swiperSpaceBetween = 16} = widget.dataset;

  const loopMode = typeof swiperLoop !== 'undefined' ? swiperLoop === 'true' : !swiperScrollbar;

  const setClassNames = swiper => {
    const {slidesPerView} = swiper.params;
    widget.classList.toggle('with-slidesPerView-auto', slidesPerView === 'auto');
    widget.classList.toggle(
      'with-arrows-between',
      swiperNextButtons.length &&
        swiperPrevButtons.length &&
        (isLargeScreen() || (!swiperScrollbar && slidesPerView !== 'auto'))
    );
    widget.classList.toggle(
      'with-arrows-hidden',
      countSlides < 2 || (slidesPerView !== 'auto' && countSlides <= slidesPerView)
    );
  };

  swiper = new Swiper(swiperEl, {
    loop: loopMode,
    scrollbar: {
      el: swiperScrollbar,
      hide: false,
      draggable: true,
    },
    simulateTouch: swiperSimulateTouch,
    spaceBetween: swiperSpaceBetween,
    navigation: {
      nextEl: [
        ...swiperNextButtons,
        id && document.querySelector(`.swiper-btn-next[data-bs-target="#${id}"]`),
      ].filter(Boolean),
      prevEl: [
        ...swiperPrevButtons,
        id && document.querySelector(`.swiper-btn-prev[data-bs-target="#${id}"]`),
      ].filter(Boolean),
    },
    breakpoints: getBreakpoints(widget),
    on: {
      init(swiper) {
        widget.classList.add('is-swiper-initialized');
        setClassNames(swiper);

        if (dropdownWrapper) {
          swiper._handlers = {
            handleDropdownShown: () => {
              swiper.update();
            },
            handleDropdownHide: e => {
              if (swiper._moved) {
                e.preventDefault();
                swiper._moved = false;
              }
            },
          };

          dropdownWrapper.addEventListener('shown.bs.dropdown', swiper._handlers.handleDropdownShown);
          dropdownWrapper.addEventListener('hide.bs.dropdown', swiper._handlers.handleDropdownHide);
        }

        swiperEl.querySelectorAll('.swiper-slide a, .swiper-slide button').forEach(link => {
          link.addEventListener('click', function (e) {
            if (swiper._moved) {
              e.preventDefault();
              e.stopPropagation();
              swiper._moved = false;
            }
          });
        });
      },
      breakpoint(swiper) {
        setClassNames(swiper);
      },
      destroy(swiper) {
        widget.classList.remove(
          'is-swiper-initialized',
          'with-scrollbar',
          'with-arrows-between',
          'with-arrows-hidden',
          'with-slidesPerView-auto'
        );
        if (dropdownWrapper && swiper._handlers) {
          dropdownWrapper.removeEventListener('shown.bs.dropdown', swiper._handlers.handleDropdownShown);
          dropdownWrapper.removeEventListener('hide.bs.dropdown', swiper._handlers.handleDropdownHide);
          swiper._handlers = null;
        }
      },
      touchStart(swiper, e) {
        const t = e.touches ? e.touches[0] : e;
        swiper._startX = t.clientX;
        swiper._startY = t.clientY;
        swiper._moved = false;
      },
      touchMove(swiper, e) {
        const MOVE_THRESHOLD = 10;
        const t = e.touches ? e.touches[0] : e;
        if (
          Math.abs(t.clientX - swiper._startX) > MOVE_THRESHOLD ||
          Math.abs(t.clientY - swiper._startY) > MOVE_THRESHOLD
        ) {
          swiper._moved = true;
        }
      },
    },
  });

  swiperEl.closest('.modal')?.addEventListener('shown.bs.modal', () => {
    swiper.update();
  });

  return {
    swipers: [swiper],
    destroy: () => {
      if (!swiper.destroyed) swiper.destroy(true, true);
    },
  };
};
